// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1uN33","select":"Header_select__1Q58I","clinic":"Header_clinic__1q0-t"};